module.exports = __webpack_public_path__ + "app/modals/api-request-access.view.html";